// The collection links row scrolls sideways on a phone, so it opens with the
// current collection's link in view rather than off the left edge.

(() => {
  document.querySelectorAll('[data-collection-links]').forEach((nav) => {
    const current = nav.querySelector('[aria-current="page"]');
    if (current && nav.scrollWidth > nav.clientWidth) {
      nav.scrollLeft = current.offsetLeft - nav.offsetLeft - 24;
    }
  });
})();
